import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NameHeader from 'components/nameHeader/NameHeader';
import { useAppSelector } from 'hooks/useRedux';
import { ConfigurableHyperLinkSelector } from 'state/hyperlink/hyperlink.selectors';
import userHeadset from './icons/user-headset.svg';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ProviderInstruction from './ProviderInstruction/ProviderInstruction';

const ProviderInstructionView = () => {
  const hyperlinks = useAppSelector(ConfigurableHyperLinkSelector);
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);

  const handleClose = () => setModalVisible(false);
  const handleShow = () => setModalVisible(true);

  const handleNextStep = () => {
    navigate('/register');
  };

  const handleGetStarted = (e: FormEvent) => {
    e.preventDefault();
    if (hyperlinks['get_started_support_modal_enabled'] === true) {
      handleShow();
    } else {
      handleNextStep();
    }
  };

  return (
    <div className="d-flex lh-1">
      <Modal
        show={modalVisible}
        onHide={handleClose}
        size="sm"
        centered
      >
        <Modal.Header
          closeButton
          className="border-0 pb-0"
        >
          <Modal.Title
            as="h5"
            className="fw-bold text-grey"
          >
            Need Help?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-grey pt-1">
          Registering to ePrescribe controlled substances is a one-time process. We recommend
          reaching out to us at (855) 863-1255, chatting with a live agent, or scheduling an
          appointment at your convenience.
        </Modal.Body>
        <Modal.Footer className="d-flex flex-column align-content-center">
          <Button
            id="support-modal-schedule-appointment"
            as="a"
            variant="danger"
            size="sm"
            className="w-100"
            href={hyperlinks['schedule_appointment_url']}
            target="_blank"
          >
            <FontAwesomeIcon icon={faCalendarDays} />
            &nbsp; Schedule an Appointment
          </Button>
          <Button
            id="support-modal-support-link"
            as="a"
            variant="danger"
            size="sm"
            className="w-100"
            href={hyperlinks['support_chat_url']}
            target="_blank"
          >
            <img
              src={userHeadset}
              width={14}
              height={14}
              style={{
                transform: 'translateY(-2px)',
              }}
            />{' '}
            &nbsp; Live Chat Support
          </Button>
          <Button
            id="support-modal-continue-registration"
            variant="text"
            size="sm"
            className="text-purple w-100"
            onClick={handleNextStep}
          >
            Continue my Registration
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <NameHeader serviceType={false} />
        <ProviderInstruction handleGetStarted={handleGetStarted} />
      </div>
    </div>
  );
};

export default ProviderInstructionView;
